import { signInWithRedirect } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { toast } from 'sonner';

import { NonAuthenticatedRoute } from '@/app/constant';
import { Button } from '@/components/ui/button';
import { validateRedirectUrl } from '@/utils/redirect.util';
import { generatePathWithSearch } from '@/utils/url.util';

export const SSO = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signInWithRedirect_failure') {
        toast.error('An error has occurred during the OAuth flow.');
      }
    });

    return unsubscribe;
  }, []);

  return (
    <>
      <div className="relative w-full text-center">
        <hr className="border-chariot-stroke absolute top-2.5 w-full border-t-2" />
        <span className="bg-chariot-background-primary relative px-8 text-center font-semibold">
          OR
        </span>
      </div>
      <Button
        className="w-full"
        variant="secondary"
        onClick={() => {
          // SECURITY: Validate redirect before storing to prevent open redirect (CWE-601)
          // Defense in depth - validate at storage AND retrieval
          const redirect = searchParams.get('redirect');
          const validatedRedirect = validateRedirectUrl(redirect);

          // Only store if validated to a non-default value
          if (validatedRedirect !== '/') {
            sessionStorage.setItem('oauth_redirect_url', validatedRedirect);
          }

          signInWithRedirect({ provider: 'Google' });
        }}
      >
        <img
          src="/icons/GoogleSSO.svg"
          alt="Google SSO"
          className="mr-2 size-5"
        />
        <span>Sign in with Google</span>
      </Button>
      <Button
        className="w-full"
        variant="secondary"
        onClick={() =>
          navigate(
            generatePathWithSearch({
              pathname: NonAuthenticatedRoute.LOGIN_SSO,
            })
          )
        }
      >
        Sign in with SSO
      </Button>
    </>
  );
};
